<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Meeting Point" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Detail Meeting Point
                    .header-cta
                        router-link.btn-default.mr-5(:to="'/multi-tracking/'+idMulti+'/detail'") Back
            .box__body.p-4
                .flex.-mx-4
                    .block.px-4(class="w-1/2")
                        span.text-light  Meeting area
                        .draw-area.box-map
                            template(v-if="meeting_point_detail.point || meeting_point_detail.target" ref="mapRef")
                                l-map(v-if="vendorMap==='osm'"  ref="mapRefOSM" :id="idOSM" :zoom="10" :center="center" :options="options" style="height: 100%;width: 100%;")
                                    l-tile-layer(:url="url" :attribution="attribution")
                                    l-marker(v-for="(location, index) in locations" :lat-lng="location.position" v-bind:key="index" :icon="getMarkerOsmIcon(location)")
                                        l-popup(:content="location.name")
                                    l-polyline(:lat-lngs="polyline.latlngs" :color="polyline.color")
                                gmap-map#map(v-else ref="mapMeetingPointRef" :center="center" :zoom="11" :options="options" style="width:100%; height: 100%;")
                            NoDataAvailable(v-else)

                    .block.px-4(class="w-1/2")
                        //- .block.mb-4
                        //-     span.text-light Meeting Name
                        //-     h3.font-normal.text-gray-800 {{ meeting_point_detail.name ? meeting_point_detail.name : '-' }}

                        //- .block.mb-4.pt-4.border-t.border-dashed
                        //-     span.text-light Description
                        //-     h3.font-normal.text-gray-800 {{ meeting_point_detail.description ? meeting_point_detail.description : '-' }}

                        template(v-if="meeting_point_detail.target && meeting_point_detail.target.length > 0")
                            .block.mb-4.pt-4.border-t.border-dashed
                                .choosen-target__list.rounded.mb-6(v-for="(target, index) in meeting_point_detail.target" :key="index")
                                    .flex.items-center.justify-between.border-b.border-b.p-4
                                        .flex.items-center
                                            figure.w-6.h-6.mr-4
                                                img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="target.photo ? target.photo : getDefaultImage" @error="getDefaultImage")
                                            span.text-light.name-index.mr-4(v-tooltip="target.target_name.length > 16 ? target.target_name : ''") {{ target.target_name ? target.target_name : '-' }}
                                            span.mr-4.info-subheader(v-if="target.deleted_at != null" v-tooltip="('Target sudah terhapus dari sistem')")
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            span.mr-8(v-else)
                                            label.mr-4(:class="[`inline-block bg-${target.label}-500 w-4 h-4 rounded-full`]")
                                            strong {{ target.msisdn }}

                                    .clues.flex.items-center.p-4
                                        //- .field(class="w-1/3" v-for="msisdn in target.msisdn")
                                        //-     .wrapper-radio
                                        //-         input(type="radio" name="msisdn" v-model="msisdn_selected" :value="msisdn" @click="selectTarget(target.id, target.target_name, target.label, msisdn)")
                                        //-         .ui-radio.flex.items-center
                                        //-             .radio.flex.items-center.justify-center
                                        //- strong {{ msisdn }}
                                        strong {{ target.location != ''? target.location : '-' }}

</template>

<script>
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import { gmapApi } from 'vue2-google-maps';
import { mapState } from 'vuex';
import Spinner from '@/components/Spinner.vue';
import moment from 'moment';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';

// openmapstreet
import { LMap, LTileLayer, LMarker, LPopup, LPolyline, LRectangle } from 'vue2-leaflet';
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.imagePath = ''
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})
export default {
    name: 'PageMultiTrackingMeetingPoint',
    components: {
        HeaderGlobal,
        Spinner,
        Loading,
        NoDataAvailable,
        DateRangePicker,
        VueAdsPagination,
        VueAdsPageButton,

        // opemapstreet
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LPolyline,
        LRectangle,
    },
    data: function () {
        return {
            breadcrumb: [
                {
                    name: 'Multi Tracking',
                    url: '/multi-tracking',
                },
                {
                    name: "Multi Tracking Detail",
                    url: '/multi-tracking/' + this.idMulti + '/detail',
                },
                {
                    name: "Meeting Point ",
                    url: '/multi-tracking/' + this.idMulti + '/meeting-point/' + this.id,
                },
            ],

            // map
            options: {
                // zoomControl: true,
                // mapTypeControl: true,
                // scaleControl: true,
                // streetViewControl: true,
                // rotateControl: true,
                // fullscreenControl: false,
                // disableDefaultUi: false
                // scrollwheel: false,
                gestureHandling: 'cooperative',
                styles: [
                    { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
                    { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
                    { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
                    {
                        featureType: 'administrative.locality',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#d59563' }]
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#d59563' }]
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'geometry',
                        stylers: [{ color: '#263c3f' }]
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#6b9a76' }]
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{ color: '#38414e' }]
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#212a37' }]
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9ca5b3' }]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{ color: '#746855' }]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#1f2835' }]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#f3d19c' }]
                    },
                    {
                        featureType: 'transit',
                        elementType: 'geometry',
                        stylers: [{ color: '#2f3948' }]
                    },
                    {
                        featureType: 'transit.station',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#d59563' }]
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{ color: '#17263c' }]
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#515c6d' }]
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#17263c' }]
                    }
                ],
            },
            infoWindows: [],
            mapLoaded: false,
            center: {},
            markers: [],
            // places: [],
            // heatmap: null,
            mapsLatLng: [],
            // rectangle_bounds: [],

            ImgAvatar: require('../../assets/no-image-profile.jpg'),
            vendorMap: (typeof process.env.VUE_APP_VENDOR_MAP !== undefined || typeof process.env.VUE_APP_VENDOR_MAP !== 'undefined' ? process.env.VUE_APP_VENDOR_MAP : 'gmap'),

            url: `${process.env.VUE_APP_OSM_CDN_URL}{z}/{x}/{y}.png`,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            // locations: {
            //     territory:[],
            //     history:[]
            // },
            locations: [],
            polyline: {
                latlngs: [],
                color: 'red'
            },
            idOSM: 'openmapstreet-detail_multitarget',
            newLoc: '',
            newLt: 0,
            newLng: 0,
            icon: L.icon({ iconUrl: "null", }),
            rectangleOSM: {
                bounds: [[-6.18188099999998, 106.8211273227539], [-6.170255000000001, 106.83286432275388]],
                style: {
                    color: "#FF0000",
                    opacity: 0.8,
                    weight: 3,
                    fillColor: "#FFFFFF",
                    fillOpacity: 0.35,
                }
            },
            rectangleHistoryOSM: {
                bounds: [[-6.18188099999998, 106.8211273227539], [-6.170255000000001, 106.83286432275388]],
                style: {
                    color: "#FF0000",
                    opacity: 0.8,
                    weight: 3,
                    fillColor: "#FFFFFF",
                    fillOpacity: 0.35,
                }
            },

            target_selected: {},
            msisdn_selected: '',
            from_date: '',
            to_date: '',

            marker_color: {
                green: '#48bb78',
                red: '#f56565',
                purple: '#9f7aea',
                orange: '#ed8936',
                blue: '#4299e1',
            },
        };
    },
    computed: {
        google: gmapApi,
        ...mapState([
            'load_data_status_meeting_point_detail',
            'meeting_point_detail',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.idMeet;
        },
        idMulti() {
            return this.$route.params.id;
        },
    },
    watch: {
        google() { },
        route_name() {
            this.getData();
        },
        id() { },
        idMulti() { },
        meeting_point_detail(newData) {
            if ((newData.target && newData.target.length > 0) || (newData.point && newData.point[0]))
                this.startMap();
        },
    },
    methods: {
        async startMap() {
            switch (this.vendorMap) {
                case 'osm':
                    await this.startMapHistoryOSM();
                    break;
                default:
                    await this.startMapHistoryGMAP();
                    break;
            }
        },
        changeImgAvatar(e) {
            const file = e.target.files[0];
            this.ImgAvatar = URL.createObjectURL(file);
        },
        getDefaultImage(e) {
            e.target.src = this.ImgAvatar;
        },
        datetimeFormat(datetime) {
            return moment(datetime, 'YYYY-MM-DDThh:mm:ssZ').format('DD MMM YYYY HH:mm:ssZ');
        },
        hideAllInfoWindows() {
            for (var j = 0; j < this.infoWindows.length; j++) {
                this.infoWindows[j].close();
            }
        },
        getMarkerOsmIcon(location) {
            let iconColor = '#ffffff'
            if (location.iconColor) {
                iconColor = location.iconColor
            }
            let stroke_width = '1.4';
            let stroke = 'black';
            // let mySvgString = '<svg width="64" height="64" viewBox="0 0 64 64" fill="<color-icon>" xmlns="http://www.w3.org/2000/svg"><path d="M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z" fill="<color-icon>" stroke="black" stroke-width="3"/><path d="M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z" fill="<color-icon>" stroke="black" stroke-width="3" stroke-linejoin="round"/></svg>'
            let mySvgString = '<svg width="64" height="64" viewBox="0 0 64 64" fill="<color-icon>" xmlns="http://www.w3.org/2000/svg"><path d="M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z" fill="<color-icon>" stroke="' + stroke + '" stroke-width="' + stroke_width + '"/><path d="M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z" fill="<color-icon>" stroke="' + stroke + '" stroke-width="' + stroke_width + '" stroke-linejoin="round"/></svg>'
            // let myIconUrl = encodeURI("data:image/svg+xml," + mySvgString).replace('<color-icon>',iconColor).replace('#','%23');
            // let myIconUrl = encodeURI("data:image/svg+xml;utf8," + mySvgString.replaceAll('<color-icon>',iconColor)).replaceAll('#','%23');
            let myIconUrl = encodeURI("data:image/svg+xml;utf8," + mySvgString.replace(/<color-icon>/g, iconColor)).replace(/#/g, '%23');

            return L.icon({
                iconUrl: myIconUrl,
                // iconSize: 40
                iconSize: 50,
                iconAnchor: [24.5, 49],
                popupAnchor: [0, -48],
            });
        },

        async startMapHistoryGMAP() {
            var self = this;
            self.mapsLatLng = [];
            self.markers = [];
            self.infoWindows = [];

            // monas, jakarta
            this.center = {
                lat: -6.1763562,
                lng: 106.8227796,
            };

            this.mapLoaded = true;

            await self.$nextTick(() => {
                self.$refs.mapMeetingPointRef.$mapPromise.then((map) => {
                    const google = self.google;

                    // map.center = new google.maps.LatLng(self.center);

                    if (self.meeting_point_detail.target && self.meeting_point_detail.target.length > 0) {
                        var bounds = new google.maps.LatLngBounds();
                        for (var i = 0; i < self.meeting_point_detail.target.length; i++) {
                            // console.log('self.meeting_point_detail')
                            // console.log(self.meeting_point_detail)
                            // console.log('self.meeting_point_detail.target[i]')
                            // console.log(self.meeting_point_detail.target[i])
                            // Object.keys(self.meeting_point_detail.target[i].location).forEach(function(k){

                            if (Object.keys(self.meeting_point_detail.target[i]).length > 0) {
                                var icon = {
                                    path: 'M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z',
                                    fillColor: self.marker_color[self.meeting_point_detail.target[i].label],
                                    fillOpacity: 1,
                                    // strokeWeight: 1.2,
                                    strokeWeight: 1.2,
                                    strokeColor: '#ffffff',
                                    // scale: 1.25,
                                    scale: .65,
                                    anchor: new google.maps.Point(30, 65),
                                }

                                let marker = new google.maps.Marker({
                                    position: new google.maps.LatLng(parseFloat(self.meeting_point_detail.target[i].coordinates[0].lat), parseFloat(self.meeting_point_detail.target[i].coordinates[0].lng)),
                                    map: map,
                                    icon: icon,
                                    // draggable: true,
                                });

                                self.markers.push(marker);

                                var circle = new google.maps.Circle({
                                    map: map,
                                    // radius: 500, // in metres
                                    radius: self.$store.getters.getMeetingPointMarkerRadius,
                                    // fillColor: '#AA0000'
                                    fillColor: self.marker_color[self.meeting_point_detail.target[i].label],
                                    fillOpacity: 0.25,
                                    strokeWeight: 1.25,
                                    strokeColor: '#ffffff',
                                    // strokeColor: '#242f3e',
                                });

                                circle.bindTo('center', marker, 'position');

                                var dtm = (self.meeting_point_detail.target[i].datetime_location ? self.datetimeFormat(self.meeting_point_detail.target[i].datetime_location) : '-');

                                var contentString = '<div id="content">' +
                                    '<div id="bodyContent">' +
                                    '<table>' +
                                    '<tr>' +
                                    '<td class="pr-1 cell-info-window">Target</td>' +
                                    '<td class="pr-1 cell-info-window">:</td>' +
                                    '<td class="cell-info-window">' + self.meeting_point_detail.target[i].target_name + '</td>' +
                                    '</tr>' +
                                    '<tr>' +
                                    '<td class="cell-info-window">MSISDN</td>' +
                                    '<td class="cell-info-window">:</td>' +
                                    '<td class="cell-info-window">' + self.meeting_point_detail.target[i].msisdn + '</td>' +
                                    '</tr>' +
                                    '<tr>' +
                                    '<td class="cell-info-window">Datetime</td>' +
                                    '<td class="cell-info-window">:</td>' +
                                    '<td class="cell-info-window">' + dtm + '</td>' +
                                    '</tr>' +
                                    '<tr>' +
                                    '<td class="cell-info-window">Link Location</td>' +
                                    '<td class="cell-info-window">:</td>' +
                                    '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q=' + self.meeting_point_detail.target[i].coordinates[0].lat + ',' + self.meeting_point_detail.target[i].coordinates[0].lng + '" style="color: #43ea92;">' + 'Google Maps</a> ' +
                                    '</td>' +
                                    '</tr>' +
                                    '</table>' +
                                    '</div>' +
                                    '</div>';

                                let infowindow = new google.maps.InfoWindow({
                                    content: contentString,
                                    maxWidth: 400
                                });

                                self.infoWindows.push(infowindow);

                                google.maps.event.addListener(marker, 'click', function () {
                                    // hideAllInfoWindows(map);
                                    self.hideAllInfoWindows();
                                    infowindow.open(map, marker);
                                });

                                // add marker to bounds
                                bounds.extend(new google.maps.LatLng(parseFloat(self.meeting_point_detail.target[i].coordinates[0].lat), parseFloat(self.meeting_point_detail.target[i].coordinates[0].lng)));

                            }

                            // });

                        }
                        // Apply fitBounds
                        map.fitBounds(bounds);

                    }
                });
            });
        },
        async startMapHistoryOSM() {
            var self = this;

            this.center = {
                lat: -6.1763562,
                lng: 106.8227796,
            };

            this.mapHistoryLoaded = true;

            self.$nextTick(() => {
                if (self.$refs.mapRefOSM && self.$refs.mapRefOSM.mapObject) {
                    const map = self.$refs.mapRefOSM.mapObject

                    if (self.meeting_point_detail.target && self.meeting_point_detail.target.length > 0) {
                        var data = self.meeting_point_detail.target
                        var bounds = []
                        // marker
                        for (var i = 0; i < data.length; i++) {
                            // console.log(i);
                            if (Object.keys(data[i].coordinates[0].lat).length > 0 && data[i].coordinates[0].lng != '') {
                                var target = data[i]
                                let latTmp = parseFloat(data[i].coordinates[0].lat);
                                let lngTmp = parseFloat(data[i].coordinates[0].lng);

                                var dtm = (data[i].datetime_location ? data[i].datetime_location : '-');

                                var contentString = '<div id="content">' +
                                    '<div id="bodyContent">' +
                                    '<table>' +
                                    '<tr>' +
                                    '<td class="pr-1 cell-info-window">Target</td>' +
                                    '<td class="pr-1 cell-info-window">:</td>' +
                                    '<td class="cell-info-window">' + target.target_name + '</td>' +
                                    '</tr>' +
                                    '<tr>' +
                                    '<td class="cell-info-window">MSISDN</td>' +
                                    '<td class="cell-info-window">:</td>' +
                                    '<td class="cell-info-window">' + target.msisdn + '</td>' +
                                    '</tr>' +
                                    '<tr>' +
                                    '<td class="cell-info-window">Datetime</td>' +
                                    '<td class="cell-info-window">:</td>' +
                                    '<td class="cell-info-window">' + dtm + '</td>' +
                                    '</tr>' +
                                    '<tr>' +
                                    '<td class="cell-info-window">Link Location</td>' +
                                    '<td class="cell-info-window">:</td>' +
                                    '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q=' + latTmp + ',' + lngTmp + '" style="color: #43ea92;">' + 'Google Maps</a> ' +
                                    '</td>' +
                                    '</tr>' +
                                    '</table>' +
                                    '</div>' +
                                    '</div>';
                                let centerTmp = [latTmp, lngTmp]
                                let labelColor = target.label
                                self.locations.push({ name: contentString, position: centerTmp, iconColor: labelColor })
                                self.polyline.latlngs.push(centerTmp)
                                self.polyline.color = labelColor

                                bounds.push(centerTmp);
                            }
                        }
                        if (bounds.length) {
                            map.fitBounds(L.latLngBounds([bounds]))
                        }
                    }
                }
            });
        },

        async getData() {
            await this.$store.commit('setMeetingPointDetail', {});
            this.$store.commit('setMeetingPointDetail', {});
            // console.log(this.route_name)
            if (this.route_name === 'PageMultiTrackingMeetingPoint') {
                this.showLoading(true);

                this.$store.dispatch('getMeetingPointDetail', [this.id])
                    .then((resp) => {
                        if (resp === 'success') {
                            this.showLoading(false);
                        } else {
                            this.error(resp);
                        }
                    });
                // this.$store.dispatch('getMeetingPointDetail', [this.id])
                // .then((resp) => {
                //     if (resp === 'success') {

                //         this.showLoading(false);

                //     } else {
                //         this.error();
                //     }
                // });
            }
        },
        showLoading(show = true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message = null, data = null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: (message !== null ? message : 'Something wrong.'),
                html: errors,
                // timer: 3000
            });
        },
    },
    async mounted() {
        // await this.startMap();
        await this.getData();
        EventEmit.$on('meetingPointNotification', () => {
            this.getData();
        });
        // console.log("this.$route.params")
        // console.log(this.$route.params)
    },
}
</script>

<style lang="sass">
    .draw-area
        height: 500px
    .cell-info-window
        vertical-align: top
</style>
